const defaultState = {
  error: "",
  isBiddingStatusRequest: false,
  appraisals: 0,
  waitingOfferingStatus: 0,
  waitingNegotiationStatus: 0,
  dealConfirmationStatus: 0,
  waitingHandoverStatus: 0,
  documentApprovalStatus: 0,
  financeApprovalStatus: 0,
  finalStatus: 0
};

const biddingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "BIDDING_STATUS_REQUEST":
      return {
        isBiddingStatusRequest: true,
      };
    case "BIDDING_STATUS_REQUEST_SUCCESS":
      return {
        ...state,
        isBiddingStatusRequest: false,
        ...action.payload,
      };
    case "BIDDING_STATUS_REQUEST_FAILED":
      return {
        isBiddingStatusRequest: false,
        erros: action.payload.e,
      };
    default:
      return state;
  }
};

export default biddingReducer;



// WEBPACK FOOTER //
// src/store/reducers/bidding.js